import React from "react"
import { FlexView } from "./components/common"
import Header from "./containers/layout/Header"
import Home from "./pages/Home"
import Logs from "./pages/Logs"
// import AccessDenied from './pages/AccessDenied'
import Login from "./pages/Login"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import PrivateRoute from "./containers/router/PrivateRoute"
import { SmartProvider } from "stores/SmartStore"
import CustomerSuccess from "pages/CustomerSucess"
import DataManagement from 'pages/DataManagement'
import { DataManagementResults } from "./pages/DataManagementResults"

const Router = () => {
  return (
    <FlexView height="100vh" minWidth="900px">
      <BrowserRouter>
        <Header />
        <Switch>
          <Route path="/login" exact>
            <Login />
          </Route>
          <PrivateRoute path="/">
            <SmartProvider>
              <Switch>
                <PrivateRoute path="/" exact>
                  <Home />
                </PrivateRoute>
                <PrivateRoute path="/customer-success" exact>
                  <CustomerSuccess />
                </PrivateRoute>
                <PrivateRoute path="/data-management" exact>
                  <DataManagement />
                </PrivateRoute>
                <PrivateRoute path="/data-management/:sellOrders" exact>
                  <DataManagementResults />
                </PrivateRoute>
                <PrivateRoute path="/logs" exact>
                  <Logs />
                </PrivateRoute>
              </Switch>
            </SmartProvider>
          </PrivateRoute>
        </Switch>
      </BrowserRouter>
    </FlexView>
  )
}

export default Router
